import React,{useState, useEffect} from 'react';
import "./css/AllCustomers.css";
import Customer from './Customer';
import { firestore, auth } from '../firebase';
import { useStateValue } from './StateProvider'
import { useHistory } from 'react-router-dom'

function AllCustomers() {
  const history = useHistory();
  const [customerIds, setCustomerIds] = useState([]);
  const [theCustomers, setTheCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [{basket, user}, dispatch] = useStateValue();

  useEffect(() => {
    const userStoriesRef = firestore.collection('customers');

    const unsubscribe = userStoriesRef.onSnapshot((querySnapshot) => {
      const ids = [];
      const userStoriesData = [];

      querySnapshot.forEach((doc) => {
        ids.push(doc.id);
        const data = doc.data();
        userStoriesData.push(data);
      });

      setCustomerIds(ids);
      setTheCustomers(userStoriesData);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const filteredCustomers = theCustomers.filter((customer) =>
    customer.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <div className='allcustomers'>
        <h3 style={{textDecoration: "underline", fontFamily: "sans-serif"}}>All Customers ({filteredCustomers.length})</h3>
        <div className='search-bar'>
        <input
          type='search'
          placeholder='Search Customer...'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        </div>

        <div className='customers-row'><div className='all-customers'>
        {filteredCustomers.length === 0 ? (
            <p style={{ textAlign: 'center', fontFamily: 'sans-serif' }}>
              No matching customers found.
            </p>
          ) : (
            filteredCustomers.map((customer, index) => (
              <Customer key={index} customer={customer} />
            ))
          )}
</div>

        </div>
    </div>
  )
}

export default AllCustomers
